import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { Button, Group, Modal, Text } from "@mantine/core";
import { IconArchive } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { editWorkflow } from "../../../../../api/WorkflowAPI";

const ArchiveWorkflow = ({ current, disabled, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);

  const main = () => {
    setLoading(true);
    editWorkflow({
      id: current.id,
      archived: true,
    })
      .then((res) => {
        close();
        notifications.show({
          message: lang.statistics.archive.success_workflow,
          color: "tertiary.8",
        });

        onFinish?.();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        onClick={open}
        leftSection={<IconArchive size={18} />}
        color="purple"
        variant="subtle"
        justify="start"
        disabled={disabled}
      >
        {lang.statistics.archive.label_workflow}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={
          <Text size="md" truncate="end">
            {lang.statistics.archive.dialog_workflow.title} #{current?.id}
          </Text>
        }
        centered
        styles={{
          content: {
            boxShadow: "red 0 0 6px",
            border: "1px solid #a00",
          },
          title: {
            maxWidth: "92%",
          },
        }}
      >
        <Text size="sm">
          {lang.statistics.archive.dialog_workflow.text} <br />
          <b>{lang.statistics.archive.dialog_workflow.text2}</b>
        </Text>

        <Group justify="end" mt={"sm"}>
          <Button variant="subtle" onClick={close} disabled={loading}>
            {lang.components.deletion_action.dialog.cancel_button}
          </Button>
          <Button color="red" onClick={main} loading={loading}>
            {lang.statistics.archive.dialog.submit_button}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ArchiveWorkflow;
